import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteCountryNominationReviewer: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  nominationReviewerId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, countryId, nominationId, nominationReviewerId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/reviewer/${nominationReviewerId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  },
).then((response) => responseErrorHandler<void>(
  fetchContext.errorStore,
  response,
  'delete country nomination reviewer',
));
